import React from 'react';
import ReactECharts from 'echarts-for-react';

const GraphView = ({ notes, connections }) => {
  const graphNodes = notes.map(note => ({
    id: note.id,
    name: note.title,
    symbolSize: note.type === 'core' ? 40 : 25,
    itemStyle: {
      color: note.type === 'core' ? '#EA580C' : '#0F172A',
      borderColor: '#FFFFFF',
      borderWidth: 2,
    },
    label: {
      show: true,
      position: 'right',
      formatter: '{b}',
      color: '#334155',
      fontSize: 12,
      fontFamily: 'Inter'
    }
  }));

  const graphEdges = connections.map(conn => ({
    source: conn.source,
    target: conn.target,
    lineStyle: {
      width: 2,
      color: '#cbd5e1',
      curveness: 0.2
    }
  }));

  const option = {
    backgroundColor: '#F8FAFC',
    tooltip: {
      trigger: 'item',
      formatter: '{b}'
    },
    series: [
      {
        type: 'graph',
        layout: 'force',
        data: graphNodes,
        edges: graphEdges,
        roam: true,
        label: {
          position: 'right'
        },
        force: {
          repulsion: 400,
          edgeLength: 150,
          gravity: 0.1
        },
        lineStyle: {
          color: 'source',
          curveness: 0.3
        },
        emphasis: {
          focus: 'adjacency',
          lineStyle: {
            width: 4
          }
        }
      }
    ]
  };

  return (
    <div className="w-full h-full bg-paper">
      <ReactECharts 
        option={option} 
        style={{ height: '100%', width: '100%' }} 
        opts={{ renderer: 'svg' }}
      />
      <div className="absolute top-6 left-6 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-lg border border-paper-dark shadow-sm">
        <h3 className="text-sm font-semibold text-ink">Knowledge Graph</h3>
        <p className="text-xs text-ink-muted">Showing {notes.length} nodes and {connections.length} links</p>
      </div>
    </div>
  );
};

export default GraphView;